<script lang="ts" setup>
import type { Props } from './types'
import { getProductTypeLabel } from '@/utils/project'
defineProps<Props>()
const { t, n } = useI18n()
</script>

<script lang="ts">
export default {
  name: 'PdFinancialInfo'
}
</script>

<template>
  <section>
    <div
      id="financial-info-price"
      class="w-full">
      <p class="text-12 lg:text-16 whitespace-nowrap">
        {{ t('from', {productType: getProductTypeLabel(listing.raw_listing.attributes.product_type, false, false, t)}) }}
      </p>

      <p class="font-semibold whitespace-nowrap text-18 lg:text-24">
        {{ n(listing.min_price, 'currency') }}

        <span class="text-12 font-regular">
          {{ listing.currency }}
        </span>
      </p>
    </div>

    <div
      v-if="listing.monthly_payments_value_raw"
      id="financial-info-monthly-payments"
      class="w-full">
      <p class="text-12 lg:text-16 whitespace-nowrap">
        {{ t('monthlyPaymentsFrom', { totalMonthlyPayments: listing.months_to_pay }) }}
      </p>

      <p class="font-semibold whitespace-nowrap text-18 lg:text-24">
        {{ n(listing.monthly_payments_value_raw, 'currency') }}

        <span class="text-12 font-regular">
          {{ listing.currency }}
        </span>
      </p>
    </div>
  </section>
</template>

<i18n lang="json" src='./i18n' />
